/* SEARCH-TAG: page-template  */
import { graphql } from 'gatsby';
import Listing from '../blogListing/_Listing';

/**
 * `/blog/category/<slug>/` and `/blog/news/`, plus their numbered pages -
 * created in gatsby-node.js. `/blog/news/` is the `thinkmoney News` category
 * under its own URL, so it keeps its own CMS-managed hero and SEO tags.
 *
 * The `filter` below MUST stay in sync with `ARTICLE_FILTER` in
 * gatsby-node.js, which derives the page count from the same set.
 */
export const pageQuery = graphql`
    query BlogCategoryListing(
        $limit: Int!
        $skip: Int!
        $categoryName: String!
    ) {
        pageContent: datoCmsBlogLandingPage {
            seoMetaTags {
                ...GatsbyDatoCmsSeoMetaTags
            }
            latestArticleText
            searchPlaceholder
        }

        newsContent: datoCmsNewsLandingPage {
            seoMetaTags {
                ...GatsbyDatoCmsSeoMetaTags
            }
            heroContent {
                ...textStructuredFields
            }
            latestArticleText
            searchPlaceholder
        }

        allArticles: allDatoCmsBlogArticle(
            filter: {
                categories: { elemMatch: { name: { eq: $categoryName } } }
                noIndex: { ne: true }
            }
            sort: [{ date: DESC }, { slug: ASC }]
            limit: $limit
            skip: $skip
        ) {
            nodes {
                id
                title
                slug
                summary
                featuredImage {
                    gatsbyImageData(
                        width: 400
                        layout: CONSTRAINED
                        placeholder: NONE
                    )
                }
                categories {
                    name
                }
            }
        }
    }
`;

export default Listing;
